class SheetLeaveService {
    /**
     * Constructs the SheetLeaveService instance.
     * @param {Object} $injector - AngularJS injector service.
     * @param {Object} $uibModal - AngularUI Bootstrap modal service.
     * @param {Object} $rootScope - AngularJS root scope service.
     */
    constructor($injector, $uibModal, $rootScope) {
        this.$injector = $injector;
        this.$uibModal = $uibModal;
        this.$rootScope = $rootScope;

        this._logIdentifier = 'SheetLeaveService';
        this.$logger = $injector.get('LogBridgeService');
        this.$logger.info(this, 'initialize');

        this._callBackObjects = [];
        this._modalInstance = null;

        this.init();
    }

    /**
     * Initializes event listeners for route changes.
     * @private
     */
    init() {
        this.$rootScope.$on('$routeChangeSuccess', (event, next, current) => {
            this.destroySheetLeaveServiceInstance();
            if (this._modalInstance) {
                this._modalInstance.dismiss('cancel');
            }
        });
    }

    /**
     * Binds a callback function to be executed on leave events.
     * @param {string} name - The name of the callback.
     * @param {Function} fn - The callback function.
     * @param {Array} args - Arguments to be passed to the callback function.
     */
    bindOnLeaveCallBack(name, fn, args) {
        this._callBackObjects.push({
            'name': name,
            'fn': fn,
            'args': args
        });
    }

    /**
     * Unbinds a previously bound callback function by name.
     * @param {string} name - The name of the callback to unbind.
     */
    unbindOnLeaveCallBack(name) {
        const callBackIndex = this._callBackObjects.findIndex(callback => callback.name === name);
        if (callBackIndex > -1) {
            this._callBackObjects.splice(callBackIndex, 1);
        }
    }

    /**
     * Executes all bound callbacks and handles the results.
     * @param {boolean} showModal - Whether to show a modal dialog if errors occur.
     * @returns {Boolean | Array<messages> | modalInstance} - Returns true if no errors, an array of messages if errors, or a modal instance if showModal is true.
     */
    sheetLeaveSuccess(showModal) {
        const messages = [];

        for (const callBack of this._callBackObjects) {
            if (callBack && callBack.fn && typeof callBack.fn === 'function') {
                const args = callBack.args || [];
                const result = callBack.fn(...args);
                if (result.error === true) {
                    messages.push(result);
                }
            }
        }

        if (showModal && messages.length > 0) {
            this._modalInstance = this.$uibModal.open({
                templateUrl: "/scripts/ib/components/sheetLeaveComponent/views/sheet-leave-modal.component.html",
                windowClass: "sheet-leave-modal",
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                controller: 'SheetLeaveModalComponent',
                resolve: {
                    messages: () => messages
                }
            });

            return this._modalInstance;
        }

        return messages.length > 0 ? messages : true;
    }

    /**
     * Destroys the current instance of the service, clearing all callbacks and data.
     */
    destroySheetLeaveServiceInstance() {
        this._callBackObjects = [];
    }
}

export default SheetLeaveService;